import * as React from 'react';
import ValidTextField from '../common/ValidTextField';
import useGlynt from '../hooks/useGlynt';
import { normalizeWhitespace } from '../../utils/stringUtils';

export interface ValidTextFieldTSProps {
  setLabel: (label: string) => void;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  placeholder?: string;
  defaultValue?: string;
  cypressId?: string;
  onKeyPress?: (event: React.KeyboardEvent) => void;
}

const NO_LOCAL_NAMES: string[] = [];

const ValidTextFieldTS: React.FC<ValidTextFieldTSProps> = ({
  setLabel,
  disabled,
  setDisabled,
  placeholder,
  defaultValue,
  cypressId,
  onKeyPress,
}) => {
  const [apiDuplicated, setApiDuplicated] = React.useState(false);
  const [lookupPending, setLookupPending] = React.useState(false);
  const [fieldInvalid, setFieldInvalid] = React.useState(false);
  const glynt = useGlynt();
  const debounceRef = React.useRef<ReturnType<typeof setTimeout>>(undefined);
  const latestValueRef = React.useRef<string>('');

  React.useEffect(() => {
    setDisabled(lookupPending || fieldInvalid);
  }, [lookupPending, fieldInvalid, setDisabled]);

  const checkApiDuplicated = (value: string) => {
    latestValueRef.current = value;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    setLabel(value.length > 0 ? value : '');

    const name = normalizeWhitespace(value);
    setLookupPending(name.length > 0);
    if (name.length === 0) {
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const client = await glynt;
        const result = await client.trainingSet.list({
          ilabel: name,
          'quick-view': 'true',
          limit: 1,
        });
        // Only apply the result if this is still the latest value
        if (latestValueRef.current === value) {
          setApiDuplicated(result.count > 0);
          setLabel(result.count > 0 ? '' : value);
        }
      } catch (err) {
        console.log(err);
      } finally {
        if (latestValueRef.current === value) {
          setLookupPending(false);
        }
      }
    }, 500);
  };

  React.useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);
  return (
    <ValidTextField
      placeholder={placeholder}
      disabled={disabled}
      cypressId={cypressId}
      setSubmitDisabled={setFieldInvalid}
      initValue={defaultValue || ''}
      names={NO_LOCAL_NAMES}
      apiDuplicated={apiDuplicated}
      setApiDuplicated={setApiDuplicated}
      checkApiDuplicated={checkApiDuplicated}
      onKeyPress={onKeyPress}
      style={{ width: '100%' }}
    />
  );
};

export default ValidTextFieldTS;
